import { useTranslation } from 'react-i18next';
import { formatIntNumber } from '@anytag/shared-utils';
import { RangeSliderInputField } from '@anytag/shared-molecules';
import { MIN_MAX_REACH_OPTIONS, MIN_REACH, MAX_REACH } from '@anytag/shared-constants';
import { InfluencersFilterFormKeys } from '../schemaTypes';

export const ReachField = () => {
  const { t } = useTranslation();

  return (
    <RangeSliderInputField<InfluencersFilterFormKeys>
      title={t('Reach')}
      options={MIN_MAX_REACH_OPTIONS}
      slideProps={{ step: 10000, min: MIN_REACH, max: MAX_REACH }}
      minField={{ name: 'minReach', placeholder: formatIntNumber(MIN_REACH) }}
      maxField={{ name: 'maxReach', placeholder: `${formatIntNumber(MAX_REACH)}+` }}
    />
  );
};
